export const Breakpoints = {
  tablet: `991px`,
  mobileLandscape: `767px`,
  mobilePortrait: `478px`,
}
